import { Navigate } from 'react-router';
import { useAuth } from '../../lib/hooks/useAuth';

/**
 * RootRedirect component for the root (/) route.
 * Redirects authenticated users to /chat and unauthenticated users to /login.
 *
 * This ensures that:
 * - Logged-in users go directly to the chat interface
 * - Logged-out users are sent to the login page
 */
export function RootRedirect() {
  const { isAuthenticated, isLoading, error } = useAuth();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="text-sm text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    );
  }

  // Show error state if authentication check failed
  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="max-w-md rounded-lg border border-destructive/50 bg-destructive/10 p-6">
          <h2 className="mb-2 text-lg font-semibold text-destructive">Errore di Autenticazione</h2>
          <p className="text-sm text-destructive/80">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 rounded-md bg-destructive px-4 py-2 text-sm font-medium text-destructive-foreground hover:bg-destructive/90"
          >
            Riprova
          </button>
        </div>
      </div>
    );
  }

  // Redirect based on authentication status
  if (isAuthenticated) {
    // Logged in → go to chat
    return <Navigate to="/chat" replace />;
  } else {
    // Not logged in → go to login page
    return <Navigate to="/login" replace />;
  }
}
